// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var $$String = require("rescript/lib/js/string.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var SetUtils$SmartcutsMacros = require("../../bs-utils/src/SetUtils.bs.js");
var HTMLNodes$SmartcutsMacros = require("./HTMLNodes.bs.js");
var ListUtils$SmartcutsMacros = require("../../bs-utils/src/ListUtils.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "id",
                Decco.optionToJson(Decco.stringToJson, v.id)
              ],
              [
                "tagName",
                Decco.optionToJson(Decco.stringToJson, v.tagName)
              ],
              [
                "classNames",
                Decco.arrayToJson(Decco.stringToJson, v.classNames)
              ],
              [
                "attributes",
                Decco.arrayToJson((function (param) {
                        return [
                                Decco.stringToJson(param[0]),
                                Decco.stringToJson(param[1])
                              ];
                      }), v.attributes)
              ],
              [
                "index",
                Decco.optionToJson(Decco.intToJson, v.index)
              ],
              [
                "innerText",
                HTMLNodes$SmartcutsMacros.InnerText.t_encode(v.innerText)
              ],
              [
                "isScrollable",
                Decco.optionToJson(Decco.boolToJson, v.isScrollable)
              ],
              [
                "attributeBlacklist",
                Decco.arrayToJson((function (param) {
                        return [
                                Decco.stringToJson(param[0]),
                                Decco.arrayToJson(Decco.stringToJson, param[1])
                              ];
                      }), v.attributeBlacklist)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var tagName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tagName"), null));
    if (tagName.TAG === /* Ok */0) {
      var classNames = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "classNames"), null));
      if (classNames.TAG === /* Ok */0) {
        var attributes = Decco.arrayFromJson((function (json) {
                var match = Js_json.classify(json);
                if (typeof match === "number") {
                  return Decco.error(undefined, "Not a tuple", json);
                }
                if (match.TAG !== /* JSONArray */3) {
                  return Decco.error(undefined, "Not a tuple", json);
                }
                var match$1 = match._0;
                if (match$1.length !== 2) {
                  return Decco.error(undefined, "Incorrect cardinality", json);
                }
                var v0 = match$1[0];
                var v1 = match$1[1];
                var match$2 = Decco.stringFromJson(v0);
                var match$3 = Decco.stringFromJson(v1);
                if (match$2.TAG === /* Ok */0) {
                  if (match$3.TAG === /* Ok */0) {
                    return {
                            TAG: /* Ok */0,
                            _0: [
                              match$2._0,
                              match$3._0
                            ]
                          };
                  }
                  var e = match$3._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                          }
                        };
                }
                var e$1 = match$2._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: "[0]" + e$1.path,
                          message: e$1.message,
                          value: e$1.value
                        }
                      };
              }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "attributes"), null));
        if (attributes.TAG === /* Ok */0) {
          var index = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "index"), null));
          if (index.TAG === /* Ok */0) {
            var innerText = HTMLNodes$SmartcutsMacros.InnerText.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "innerText"), null));
            if (innerText.TAG === /* Ok */0) {
              var isScrollable = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "isScrollable"), null));
              if (isScrollable.TAG === /* Ok */0) {
                var attributeBlacklist = Decco.arrayFromJson((function (json) {
                        var match = Js_json.classify(json);
                        if (typeof match === "number") {
                          return Decco.error(undefined, "Not a tuple", json);
                        }
                        if (match.TAG !== /* JSONArray */3) {
                          return Decco.error(undefined, "Not a tuple", json);
                        }
                        var match$1 = match._0;
                        if (match$1.length !== 2) {
                          return Decco.error(undefined, "Incorrect cardinality", json);
                        }
                        var v0 = match$1[0];
                        var v1 = match$1[1];
                        var match$2 = Decco.stringFromJson(v0);
                        var match$3 = Decco.arrayFromJson(Decco.stringFromJson, v1);
                        if (match$2.TAG === /* Ok */0) {
                          if (match$3.TAG === /* Ok */0) {
                            return {
                                    TAG: /* Ok */0,
                                    _0: [
                                      match$2._0,
                                      match$3._0
                                    ]
                                  };
                          }
                          var e = match$3._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: "[1]" + e.path,
                                    message: e.message,
                                    value: e.value
                                  }
                                };
                        }
                        var e$1 = match$2._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: "[0]" + e$1.path,
                                  message: e$1.message,
                                  value: e$1.value
                                }
                              };
                      }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "attributeBlacklist"), null));
                if (attributeBlacklist.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            id: id._0,
                            tagName: tagName._0,
                            classNames: classNames._0,
                            attributes: attributes._0,
                            index: index._0,
                            innerText: innerText._0,
                            isScrollable: isScrollable._0,
                            attributeBlacklist: attributeBlacklist._0
                          }
                        };
                }
                var e = attributeBlacklist._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".attributeBlacklist" + e.path,
                          message: e.message,
                          value: e.value
                        }
                      };
              }
              var e$1 = isScrollable._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".isScrollable" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = innerText._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".innerText" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = index._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".index" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
        }
        var e$4 = attributes._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".attributes" + e$4.path,
                  message: e$4.message,
                  value: e$4.value
                }
              };
      }
      var e$5 = classNames._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".classNames" + e$5.path,
                message: e$5.message,
                value: e$5.value
              }
            };
    }
    var e$6 = tagName._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".tagName" + e$6.path,
              message: e$6.message,
              value: e$6.value
            }
          };
  }
  var e$7 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$7.path,
            message: e$7.message,
            value: e$7.value
          }
        };
}

function maybeGetAttributeValue(attr, param) {
  return OptionUtils$SmartcutsMacros.map(Belt_Array.getBy(param.attributes, (function (param) {
                    return param[0] === attr;
                  })), (function (prim) {
                return prim[1];
              }));
}

function deepEquals(aNode, bNode) {
  if (!Caml_obj.caml_equal(aNode.id, bNode.id)) {
    return false;
  }
  if (!Caml_obj.caml_equal(aNode.tagName, bNode.tagName)) {
    return false;
  }
  var aClassNames = new Set(aNode.classNames);
  var bClassNames = new Set(bNode.classNames);
  if (!SetUtils$SmartcutsMacros.isSameSetAs(aClassNames, bClassNames)) {
    return false;
  }
  if (!Caml_obj.caml_equal(aNode.index, bNode.index)) {
    return false;
  }
  if (!Caml_obj.caml_equal(aNode.isScrollable, bNode.isScrollable)) {
    return false;
  }
  if (!HTMLNodes$SmartcutsMacros.InnerText.equals(aNode.innerText, bNode.innerText)) {
    return false;
  }
  var keysA = new Set(Belt_Array.map(aNode.attributes, (function (prim) {
              return prim[0];
            })));
  var keysB = new Set(Belt_Array.map(bNode.attributes, (function (prim) {
              return prim[0];
            })));
  var allKeys = SetUtils$SmartcutsMacros.union(keysA, keysB);
  var aKeyVals = Belt_MapString.fromArray(aNode.attributes);
  var bKeyVals = Belt_MapString.fromArray(bNode.attributes);
  if (!Belt_Array.reduce(Array.from(allKeys), true, (function (acc, key) {
            var aVal = Belt_MapString.get(aKeyVals, key);
            var bVal = Belt_MapString.get(bKeyVals, key);
            if (acc) {
              return Caml_obj.caml_equal(aVal, bVal);
            } else {
              return false;
            }
          }))) {
    return false;
  }
  var keysA$1 = new Set(Belt_Array.map(aNode.attributeBlacklist, (function (prim) {
              return prim[0];
            })));
  var keysB$1 = new Set(Belt_Array.map(bNode.attributeBlacklist, (function (prim) {
              return prim[0];
            })));
  var allKeys$1 = SetUtils$SmartcutsMacros.union(keysA$1, keysB$1);
  var aKeyVals$1 = Belt_MapString.fromArray(aNode.attributeBlacklist);
  var bKeyVals$1 = Belt_MapString.fromArray(bNode.attributeBlacklist);
  return Belt_Array.reduce(Array.from(allKeys$1), true, (function (acc, key) {
                var match = Belt_MapString.get(aKeyVals$1, key);
                var match$1 = Belt_MapString.get(bKeyVals$1, key);
                if (match === undefined) {
                  return false;
                }
                if (match$1 === undefined) {
                  return false;
                }
                var aBlacklistValuesSet = new Set(match);
                var bBlacklistValuesSet = new Set(match$1);
                if (acc) {
                  return SetUtils$SmartcutsMacros.isSameSetAs(aBlacklistValuesSet, bBlacklistValuesSet);
                } else {
                  return false;
                }
              }));
}

function allWithNode(aNode, bNode) {
  var aClassNames = new Set(aNode.classNames);
  var bClassNames = new Set(bNode.classNames);
  var classNameDiffAB = SetUtils$SmartcutsMacros.subtract(aClassNames, bClassNames);
  var classNameDiffBA = SetUtils$SmartcutsMacros.subtract(bClassNames, aClassNames);
  var classNameIntersect = SetUtils$SmartcutsMacros.intersect(aClassNames, bClassNames);
  return List.fold_left((function (res, param) {
                if (param[0]) {
                  return List.append(res, {
                              hd: param[1],
                              tl: /* [] */0
                            });
                } else {
                  return res;
                }
              }), /* [] */0, {
              hd: [
                Caml_obj.caml_notequal(aNode.id, bNode.id),
                {
                  TAG: /* Id */0,
                  _0: aNode.id,
                  _1: bNode.id
                }
              ],
              tl: {
                hd: [
                  Caml_obj.caml_notequal(aNode.tagName, bNode.tagName),
                  {
                    TAG: /* TagName */1,
                    _0: aNode.tagName,
                    _1: bNode.tagName
                  }
                ],
                tl: {
                  hd: [
                    !(SetUtils$SmartcutsMacros.isEmpty(classNameDiffAB) && SetUtils$SmartcutsMacros.isEmpty(classNameDiffBA)),
                    {
                      TAG: /* ClassNames */3,
                      _0: Array.from(classNameDiffAB),
                      _1: Array.from(classNameDiffBA),
                      _2: Array.from(classNameIntersect)
                    }
                  ],
                  tl: {
                    hd: [
                      Caml_obj.caml_notequal(aNode.index, bNode.index),
                      {
                        TAG: /* Index */2,
                        _0: aNode.index,
                        _1: bNode.index
                      }
                    ],
                    tl: /* [] */0
                  }
                }
              }
            });
}

function withNode(aNode, bNode) {
  var match = allWithNode(aNode, bNode);
  if (!match) {
    return /* NoDiff */0;
  }
  var diff = match.hd;
  return diff;
}

var Diff = {
  allWithNode: allWithNode,
  withNode: withNode
};

function fromSelectorNode(node) {
  var isScrollable = node.isScrollable;
  return Belt_List.concatMany([
              OptionUtils$SmartcutsMacros.toList(OptionUtils$SmartcutsMacros.$neg$question$great(node.tagName, (function (tagName) {
                          return {
                                  TAG: /* TagName */0,
                                  _0: tagName
                                };
                        }))),
              OptionUtils$SmartcutsMacros.toList(OptionUtils$SmartcutsMacros.$neg$question$great(node.id, (function (id) {
                          return {
                                  TAG: /* Id */1,
                                  _0: id
                                };
                        }))),
              $$Array.to_list($$Array.map((function (className) {
                          return {
                                  TAG: /* ClassName */2,
                                  _0: className
                                };
                        }), node.classNames)),
              $$Array.to_list($$Array.map((function (param) {
                          return {
                                  TAG: /* Attribute */3,
                                  _0: param[0],
                                  _1: param[1]
                                };
                        }), node.attributes)),
              OptionUtils$SmartcutsMacros.toList(OptionUtils$SmartcutsMacros.$neg$question$great(node.index, (function (index) {
                          return {
                                  TAG: /* AtIndex */4,
                                  _0: index
                                };
                        }))),
              isScrollable !== undefined ? ({
                    hd: {
                      TAG: /* IsScrollable */6,
                      _0: isScrollable
                    },
                    tl: /* [] */0
                  }) : /* [] */0
            ]);
}

function toNode(components) {
  var tagName = ListUtils$SmartcutsMacros.shortcut((function (v) {
          if (v.TAG === /* TagName */0) {
            return v._0;
          }
          
        }), components);
  var id = ListUtils$SmartcutsMacros.shortcut((function (v) {
          if (v.TAG === /* Id */1) {
            return v._0;
          }
          
        }), components);
  var classNames = Belt_List.reduce(components, [], (function (classNames, component) {
          if (component.TAG === /* ClassName */2) {
            return $$Array.append(classNames, [component._0]);
          } else {
            return classNames;
          }
        }));
  var attributes = Belt_List.reduce(components, [], (function (attributes, component) {
          if (component.TAG === /* Attribute */3) {
            return $$Array.append(attributes, [[
                          component._0,
                          component._1
                        ]]);
          } else {
            return attributes;
          }
        }));
  var index = ListUtils$SmartcutsMacros.shortcut((function (v) {
          if (v.TAG === /* AtIndex */4) {
            return v._0;
          }
          
        }), components);
  var maybeInnerText = ListUtils$SmartcutsMacros.shortcut((function (v) {
          if (v.TAG === /* InnerText */5) {
            return v._0;
          }
          
        }), components);
  var maybeIsScrollable = ListUtils$SmartcutsMacros.shortcut((function (v) {
          if (v.TAG === /* IsScrollable */6) {
            return v._0;
          }
          
        }), components);
  return {
          id: id,
          tagName: tagName,
          classNames: classNames,
          attributes: attributes,
          index: index,
          innerText: maybeInnerText !== undefined ? ({
                TAG: /* FullInnerText */0,
                _0: maybeInnerText
              }) : /* NoInnerText */1,
          isScrollable: maybeIsScrollable,
          attributeBlacklist: []
        };
}

var Components = {
  fromSelectorNode: fromSelectorNode,
  toNode: toNode
};

function maybeStringifyAttributeKey(attrKey) {
  if (attrKey === "xmlns") {
    return ;
  }
  if (attrKey.indexOf(":") <= -1) {
    return window.CSS.escape(attrKey);
  }
  var arg = ArrayUtils$SmartcutsMacros.last(attrKey.split(":"));
  var keyWithoutNamespace = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
      })("Expect to get attribute key after namespace prefix from attribute " + StringUtils$SmartcutsMacros.quote(attrKey));
  return "*|" + window.CSS.escape(keyWithoutNamespace);
}

function stringify(node) {
  var expr = $$String.concat("", Belt_List.map(fromSelectorNode(node), (function (component) {
              switch (component.TAG | 0) {
                case /* TagName */0 :
                    return component._0;
                case /* Id */1 :
                    return "#" + window.CSS.escape(component._0);
                case /* ClassName */2 :
                    return "." + window.CSS.escape(component._0);
                case /* Attribute */3 :
                    var value = component._1;
                    var key2 = maybeStringifyAttributeKey(component._0);
                    if (key2 === undefined) {
                      return "";
                    }
                    if (value === "") {
                      return "[" + key2 + "]";
                    }
                    var escapedValue = window.CSS.escape(value);
                    return "[" + key2 + "=\"" + escapedValue + "\"]";
                case /* AtIndex */4 :
                    return ":nth-child(" + component._0 + ")";
                case /* InnerText */5 :
                case /* IsScrollable */6 :
                    return "";
                
              }
            })));
  var match = node.tagName;
  if (match !== undefined) {
    return expr;
  } else {
    return "*" + expr;
  }
}

function fromHtmlNode(childIndex, htmlNode) {
  if (htmlNode.TAG === /* DocumentFragmentNode */0) {
    return {
            id: undefined,
            tagName: htmlNode._0.nodeName,
            classNames: [],
            attributes: [],
            index: childIndex,
            innerText: /* Ignored */0,
            isScrollable: undefined,
            attributeBlacklist: []
          };
  }
  var elementNode = htmlNode._0;
  var element = elementNode.element;
  var scrollHeight = element.scrollHeight;
  var isScrollable = Belt_Option.map(elementNode.shape, (function (param) {
          var hasScrollableContent = scrollHeight > param.clientHeight;
          var computedStyle = window.getComputedStyle(element);
          var isOverflowHidden = computedStyle.overflowY.includes("hidden");
          if (hasScrollableContent) {
            return !isOverflowHidden;
          } else {
            return false;
          }
        }));
  return {
          id: elementNode.id,
          tagName: elementNode.tagName,
          classNames: elementNode.classNames,
          attributes: elementNode.attributes,
          index: childIndex,
          innerText: elementNode.innerText,
          isScrollable: isScrollable,
          attributeBlacklist: []
        };
}

var $$Node = {
  t_encode: t_encode,
  t_decode: t_decode,
  maybeGetAttributeValue: maybeGetAttributeValue,
  deepEquals: deepEquals,
  Diff: Diff,
  Components: Components,
  maybeStringifyAttributeKey: maybeStringifyAttributeKey,
  stringify: stringify,
  fromHtmlNode: fromHtmlNode
};

function t_encode$1(v) {
  return Decco.listToJson(t_encode, v);
}

function t_decode$1(v) {
  return Decco.listFromJson(t_decode, v);
}

function findIndex(cond, iter, x) {
  var _index = 1;
  var _x = x;
  while(true) {
    var x$1 = _x;
    var index = _index;
    if (Curry._1(cond, x$1)) {
      return index;
    }
    var x$p = Curry._1(iter, x$1);
    if (x$p === undefined) {
      return ;
    }
    _x = Caml_option.valFromOption(x$p);
    _index = index + 1 | 0;
    continue ;
  };
}

function determineChildIndex(htmlNode, parentHtmlNode) {
  if (htmlNode.TAG === /* DocumentFragmentNode */0) {
    return ;
  }
  var elementNode = htmlNode._0;
  var firstSibling;
  firstSibling = parentHtmlNode.TAG === /* DocumentFragmentNode */0 ? Caml_option.nullable_to_opt(parentHtmlNode._0.firstElementChild) : Caml_option.nullable_to_opt(parentHtmlNode._0.element.firstElementChild);
  return findIndex((function (sibling) {
                if (sibling !== undefined) {
                  return Caml_option.valFromOption(sibling) === elementNode.element;
                } else {
                  return false;
                }
              }), (function (sibling) {
                return OptionUtils$SmartcutsMacros.$neg$question$great(sibling, (function (prim) {
                              return Caml_option.nullable_to_opt(prim.nextElementSibling);
                            }));
              }), firstSibling);
}

function fromHTMLNodes(htmlNodes) {
  var lastNodeIndex = List.length(htmlNodes) - 1 | 0;
  return List.rev(Belt_List.mapWithIndex(htmlNodes, (function (i, htmlNode) {
                    if (i === lastNodeIndex) {
                      if (htmlNode.TAG === /* DocumentFragmentNode */0) {
                        console.warn("Expected last node to be 'body'; got #document-fragment; beware using a selector derived from this");
                      } else {
                        var tagName = htmlNode._0.tagName;
                        if (Caml_obj.caml_notequal(tagName, "body")) {
                          console.warn("Expected last node to be 'body'; got " + (OptionUtils$SmartcutsMacros.withDefault("undefined", tagName) + "; beware using a selector derived from this since element may have been removed from page"));
                        }
                        
                      }
                      return fromHtmlNode(undefined, htmlNode);
                    }
                    var childIndex = determineChildIndex(htmlNode, Belt_List.getExn(htmlNodes, i + 1 | 0));
                    return fromHtmlNode(childIndex, htmlNode);
                  })));
}

function processInnerText(innerTextMaxLen, keepLastNLevels, alwaysKeepTags, alwaysIgnoreTags, tree) {
  var treeLen = List.length(tree);
  return List.mapi((function (i, node) {
                var innerText = node.innerText;
                var tagName = node.tagName;
                var tmp;
                var exit = 0;
                if (tagName !== undefined) {
                  if ($$Array.exists((function (allowedTag) {
                            return tagName === $$String.lowercase_ascii(allowedTag) ? true : tagName === $$String.uppercase_ascii(allowedTag);
                          }), alwaysKeepTags)) {
                    tmp = innerText;
                  } else if (Belt_Array.some(alwaysIgnoreTags, (function (tagToIgnore) {
                            return tagName === $$String.lowercase_ascii(tagToIgnore) ? true : tagName === $$String.uppercase_ascii(tagToIgnore);
                          }))) {
                    tmp = /* Ignored */0;
                  } else {
                    exit = 1;
                  }
                } else {
                  exit = 1;
                }
                if (exit === 1) {
                  if (typeof innerText === "number") {
                    tmp = innerText;
                  } else {
                    var text = innerText._0;
                    tmp = keepLastNLevels === -1 || i >= (treeLen - keepLastNLevels | 0) ? (
                        text.length <= innerTextMaxLen ? ({
                              TAG: /* FullInnerText */0,
                              _0: text
                            }) : ({
                              TAG: /* TruncatedInnerText */1,
                              _0: $$String.sub(text, 0, innerTextMaxLen),
                              _1: text.length
                            })
                      ) : /* Ignored */0;
                  }
                }
                return {
                        id: node.id,
                        tagName: node.tagName,
                        classNames: node.classNames,
                        attributes: node.attributes,
                        index: node.index,
                        innerText: tmp,
                        isScrollable: node.isScrollable,
                        attributeBlacklist: node.attributeBlacklist
                      };
              }), tree);
}

function maybeGetLeafNode(tree) {
  var len = List.length(tree);
  if (len !== 0) {
    return Belt_List.get(tree, len - 1 | 0);
  }
  
}

function stringify$1(useScope, selectorNodes) {
  return Belt_List.reduce(selectorNodes, useScope ? ":scope" : "", (function (prevString, node) {
                var stringifiedNode = stringify(node);
                if (node.index !== undefined) {
                  if (prevString === "") {
                    return stringifiedNode;
                  } else {
                    return prevString + (" > " + stringifiedNode);
                  }
                } else {
                  return prevString + (" " + stringifiedNode);
                }
              }));
}

exports.$$Node = $$Node;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
exports.findIndex = findIndex;
exports.determineChildIndex = determineChildIndex;
exports.fromHTMLNodes = fromHTMLNodes;
exports.processInnerText = processInnerText;
exports.maybeGetLeafNode = maybeGetLeafNode;
exports.stringify = stringify$1;
/* HTMLNodes-SmartcutsMacros Not a pure module */
